/*
 * File: UpdateCourseEnrollmentSchema.ts
 * Author: Austin Robinson
 * Date Created: 4/27/2025
 * Copyright (c) DrivingDoc 2025
 */
import dayjs from 'dayjs';
import { z } from 'zod';

export const UpdateCourseEnrollmentSchema = z.object({
  completionDate: z
    .string()
    .date()
    .default(() => dayjs().startOf('day').toISOString())
    .transform((val) => dayjs(val).startOf('day').toISOString()),
});

export type UpdateCourseEnrollmentFormValues = z.infer<typeof UpdateCourseEnrollmentSchema>;
